import React from 'react';
import { Input, Icon, List, Checkbox } from 'antd';
import classnames from 'classnames';

import User from './User';
import styles from '../styles.module.scss';

const { Search } = Input;

export class UsersList extends React.Component {
  state = {
    filtered: true,
  }

  handleChange = () =>
    this.setState(({ filtered: prevFiltered }) => ({ filtered: !prevFiltered }));

  usersFilter = ({ groups = [] }) => {
    if (!this.state.filtered) {
      return true;
    }

    return !!groups.includes('staff');
  }

  render () {
    const { loading, users, search, editUser, deleteUser } = this.props;
    const { filtered } = this.state;
    return (
      <div
        className={styles.usersList}
      >
        <Search
          placeholder="Rechercher un agent"
          onChange={search}
        />

        <Checkbox
          checked={!filtered}
          className={styles.usersList__filter}
          onChange={this.handleChange}
        >
          Afficher tous les utilisateurs
        </Checkbox>

        {loading && (
          <Icon
            type="loading"
            theme="outlined"
            spin
          />
        )}

        {!loading && (
          <div>
            <List
              className={styles.usersList__list}
              dataSource={users.filter(this.usersFilter)}
              renderItem={({
                id,
                email,
                groups,
                properties: { structure: { name } = {} } = {},
              }) => (
                <User
                  key={id}
                  className={classnames({
                    [styles.usersList__item]: true,
                    [styles.usersList__itemStaff]: groups.includes('staff'),
                  })}
                  id={id}
                  name={name || email}
                  email={name ? email : ''}
                  onEdit={editUser}
                  onDelete={deleteUser}
                />
              )}
            />
          </div>
        )}
      </div>
    );
  }
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UsersList/render.js